import { AuthError } from "@azure/msal-browser-1p";

// Wrap any thrown value into a proper AuthError so downstream telemetry always
// carries a non-empty errorCode. Some MSAL code paths reject
// with native errors like SyntaxError that have .name / .message but no
// .errorCode / .errorMessage / .subError, which would otherwise be logged as
// MsalAuthError with an empty AuthError column.
export function toAuthError(e: unknown, correlationId: string): AuthError {
    if (e instanceof AuthError) {
        return e;
    }
    
    const err = e as {
        name?: string;
        message?: string;
    } | null | undefined;
    const code = err?.name || "NonAuthError";
    const message = err?.message || (e == null ? "" : String(e));
    return new AuthError(code, correlationId, message);
}
